/**
 * Qué avisarle al contador sobre sus timbres. `null` = no dibujar nada.
 *
 * Vive aparte del componente por dos razones: el linter lo pide --exportar una función junto a
 * un componente rompe el fast refresh-- y, sobre todo, porque **la decisión de cuándo callarse
 * es la mitad del valor** y dentro del render no se puede probar sin pelear con el ciclo de vida
 * de la query. Dos mutaciones sobrevivieron mientras esto estuvo dentro del componente.
 */
const VARIANTE = {
  bloqueo: 'danger',
  critico: 'danger',
  advertencia: 'warning',
  aviso: 'info',
}

export function calcularAviso(data) {
  if (!data?.con_licencia) return null

  const timbres = data.timbres || {}

  if (data.alerta) {
    const nivel = data.alerta.nivel
    const esBloqueo = nivel === 'bloqueo'
    return {
      variante: VARIANTE[nivel] || 'info',
      esBloqueo,
      texto: esBloqueo
        ? 'Te quedaste sin timbres: no se puede emitir hasta recargar.'
        : `${data.alerta.mensaje} Conviene recargar antes de quedarte sin poder facturar.`,
      contador: `${timbres.disponibles} de ${timbres.otorgados}`,
    }
  }

  // Sin alerta de saldo pero impedido por otra razón --vigencia vencida, licencia
  // suspendida--: hay que decirlo igual.
  if (!data.puede_timbrar && data.motivo_timbrado) {
    return { variante: 'danger', esBloqueo: true, texto: data.motivo_timbrado, contador: null }
  }

  // Todo en orden: callarse. Una barra permanente deja de leerse.
  return null
}

